$(function() {
    $('.container').css('background-color', 'rgba(0, 0, 0, 0)');
    $('article *').each(function() {
        $(this).css('opacity', '1');
    });

});